import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHashtag } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Alert,
} from "@themesberg/react-bootstrap";
import { useNavigate } from "react-router-dom";

import {
  ChangeEmailOTP,
  ResendOTP,
  VerificationOTP,
  reset,
} from "../../../features/OTPSlice";
import BgImage from "../../../assets/img/illustrations/signin.svg";
import { showSuccessDialog } from "../../../helpers/dialog.helper";

const AuthOtp = () => {
  const [changeForm, setChangeForm] = useState(true);
  const [email, setEmail] = useState("");
  const [dataOTP, setDataOTP] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = localStorage.getItem("userData");
  const token = localStorage.getItem("token");
  const { isLoading, isSuccess, message, isError } = useSelector(
    (state) => state.otp
  );

  useEffect(() => {
    if (!token || !userData) {
      navigate("/");
    } else {
      if (JSON.parse(localStorage.getItem("userData")).status === "1") {
        navigate("/dashboard");
      }
    }
  }, [token, navigate, userData]);

  const onChangeEmailSuccess = (result) => {
    setChangeForm(true);
    showSuccessDialog({
      title: "Berhasil!",
      msg:
        result?.message || "Berhasil mengubah email, silahkan cek email anda!",
    });
    dispatch(reset());
  };

  const onVerifOTPSuccess = (result) => {
    navigate("/dashboard");
    showSuccessDialog({
      title: "Berhasil!",
      msg: result?.message || "Berhasil melakukan verifikasi!",
    });
    dispatch(reset());
  };

  const handleResendOTP = async () => {
    dispatch(reset());
    dispatch(ResendOTP(token));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (changeForm) {
      dispatch(reset());
      dispatch(VerificationOTP({ dataOTP, token, cb: onVerifOTPSuccess }));
    } else {
      dispatch(reset());
      dispatch(
        ChangeEmailOTP({
          email,
          token,
          cb: onChangeEmailSuccess,
        })
      );
    }
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row
            className="justify-content-center form-bg-image"
            style={{ backgroundImage: `url(${BgImage})` }}
          >
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  {changeForm ? (
                    <>
                      <h3 className="mb-0">Masukan OTP</h3>
                      <p>
                        Kami telah mengirimkan kode OTP ke email anda silahkan
                        cek!
                      </p>
                    </>
                  ) : (
                    <>
                      <h3 className="mb-0">Masukan Email</h3>
                      <p>Kami akan mengirimkan kode OTP ke email anda isi!</p>
                    </>
                  )}
                </div>
                {isError && message ? (
                  <Alert variant="danger">{message?.message}</Alert>
                ) : null}

                {changeForm ? (
                  <Form className="mt-4" onSubmit={handleSubmit}>
                    <Form.Group id="otp" className="mb-4">
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faHashtag} />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          required
                          type="text"
                          value={dataOTP || ""}
                          onChange={(e) => setDataOTP(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={isLoading}
                    >
                      {isLoading ? "Loading..." : "Verifikasi"}
                    </Button>
                  </Form>
                ) : (
                  <Form className="mt-4" onSubmit={handleSubmit}>
                    <Form.Group id="email" className="mb-4">
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faHashtag} />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          required
                          type="email"
                          value={email || ""}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={isLoading}
                    >
                      {isLoading ? "Loading..." : "Kirim"}
                    </Button>
                  </Form>
                )}

                <div className="d-flex justify-content-center align-items-center mt-4">
                  {changeForm ? (
                    <span className="fw-normal">
                      Belum terkirim?
                      <Card.Link onClick={handleResendOTP} className="fw-bold">
                        {` Kirim lagi `}
                      </Card.Link>
                      atau
                      <Card.Link
                        onClick={() => setChangeForm(!changeForm)}
                        className="fw-bold"
                        style={{ margin: 0 }}
                      >
                        {` Ganti email? `}
                      </Card.Link>
                    </span>
                  ) : (
                    <Card.Link
                      onClick={() => setChangeForm(!changeForm)}
                      className="fw-bold"
                    >
                      {` Batal `}
                    </Card.Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default AuthOtp;
